//port { HttpClient } from '@angular/common/http};
import { Component, inject, Input, OnChanges, SimpleChange, SimpleChanges } from '@angular/core';
import { Bundle, CodeableReference, Dosage, FhirResource, Medication, MedicationRequest, Reference, Resource } from 'fhir/r5';
import { ActivatedRoute, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatTableDataSource, MatTableModule } from '@angular/material/table'
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon'
import { MatExpansionModule } from '@angular/material/expansion'
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatMenuModule } from '@angular/material/menu'
import { MatInputModule } from '@angular/material/input'
import { MatFormField } from '@angular/material/input';
import { MatDividerModule } from '@angular/material/divider'
import { MatChipsModule } from '@angular/material/chips'
import { AsyncPipe, CommonModule, DatePipe, TitleCasePipe } from '@angular/common';
import { BehaviorSubject, forkJoin, map, Observable, tap } from 'rxjs';
import { HttpClient, HttpContext } from '@angular/common/http';
import { baseStatusStyles } from '../statusUIIcons';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { medicationIntentStyles } from '../intentIconStyles';
import { ReferencePipe } from '../pipes/CodeableReference.pipe';
import { CodeableReferencePipe } from '../codeable-reference.pipe';
import { FhirReferenceLabelPipe } from '../pipes/Reference.pipe';
import { CodeableConceptLabelPipe } from '../pipes/CodeableConcept.pipe';
import { MatDialog } from '@angular/material/dialog';
import { DynamicFormsV2Component } from '../dynamic-forms-v2/dynamic-forms-v2.component';
import { formMetaData, formFields } from '../dynamic-forms.interface';
import {
  CodeableConceptField, CodeField, GroupField, IndividualField,
  codeableConceptDataType, ReferenceDataType, codingDataType,
  IndividualReferenceField, ReferenceFieldArray,
  SingleCodeField
} from '../dynamic-forms.interface2';
import { FormFieldsSelectDataService } from '../form-fields-select-data.service';
import { ErrorService } from '../error.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { LoadingUIEnabled } from '../../loading.interceptor';
import { RESOURCE_PROPERTY_TYPES } from '../fhir-resource-transform.service';
import { ReferenceDisplayDirective } from '../reference-display.directive';


import { backendEndPointToken } from '../../app.config';

type FormFields = IndividualField | ReferenceFieldArray | CodeableConceptField | CodeField | IndividualReferenceField | GroupField;


@Component({
  selector: 'app-detail-base',


  imports:
    [MatCardModule, MatButtonModule,
      MatFormField, MatDividerModule, DatePipe, RouterLink,
      RouterLinkActive, CommonModule,
      MatExpansionModule, MatCheckboxModule, TitleCasePipe,
      MatTableModule, AsyncPipe,
      MatChipsModule, ReferenceDisplayDirective,
      MatInputModule, ReferencePipe, CodeableConceptLabelPipe,
      MatMenuModule, CodeableReferencePipe, FhirReferenceLabelPipe,
      MatTableModule, MatIconModule, ReactiveFormsModule, MatProgressSpinnerModule,],
  templateUrl: './detail-base.component.html',
  styleUrl: './detail-base.component.scss'
})
export class DetailBaseComponent implements OnChanges {
  @Input() url!: string;
  @Input() exclude: string[] = [];
  @Input() onlyInclude: string[] = [];
  keyTypes = RESOURCE_PROPERTY_TYPES;
  http = inject(HttpClient);
  backendApiBaseUrl = inject(backendEndPointToken)

  resource: any = "";
  statuStyles: any;
  intentStyles: any;
  onLoading$ = new BehaviorSubject<boolean>(true);
  ngOnInit() {
    this.statuStyles = baseStatusStyles;
    this.intentStyles = medicationIntentStyles;
    this.fetchResource(this.url);
  }

  ngOnChanges(changes: SimpleChanges): void {
    const urlChange = changes['url'];
    if (urlChange?.currentValue && !urlChange.firstChange && urlChange.currentValue !== urlChange.previousValue) {
// $#$      // /* alert("url changed "+urlChange.currentValue); */
      this.fetchResource(urlChange.currentValue);
    }
  }

  private fetchResource(url?: string): void {
    if (!url) return;

    this.onLoading$.next(true);

    // ✅ FIXED: Handle both full URLs and relative URLs
    let finalUrl = url;

    // If URL is just a path or relative reference, prepend the backend base URL
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      // Relative URL - prepend base
      finalUrl = `${this.backendApiBaseUrl}${url}`;
    } else if (url === this.backendApiBaseUrl || url.endsWith('.daalitech.com')) {
      // Base URL only - don't fetch
      console.warn('⚠️ Received base URL without resource endpoint:', url);
      this.onLoading$.next(false);
      return;
    }

    // ✅ Add format parameter correctly
    if (finalUrl.includes('?')) {
      finalUrl = `${finalUrl}&_format=json`;
    } else {
      finalUrl = `${finalUrl}?_format=json`;
    }

    console.log('📥 Fetching resource from:', finalUrl);

    this.http.get<any>(finalUrl, {
      context: new HttpContext().set(LoadingUIEnabled, false)
    })
      .pipe(map((dataBundle) => dataBundle ?? ''))
      .subscribe({
        next: (resource) => {
          console.log('✅ Resource loaded successfully');
          this.resource = resource;
          this.onLoading$.next(false);
        },
        error: (e) => {
          console.error('❌ Failed to load resource:', e);
          this.onLoading$.next(false);
          // Only show error if it's not a base URL error
          if (!url.endsWith('.daalitech.com')) {
            this.errorService.openandCloseError('Failed to load resource details');
          }
        }
      });
  }


  sortAccordingToSequence(dosageArray: any[]): Dosage[] {
    return dosageArray.sort((a: Dosage, b: Dosage) => {
      if (a.sequence && b.sequence) {
        return a.sequence - b.sequence
      } else {
        return 0
      }
    })
  }

  // renderOtherFields(data: any, startKey: string, exclude: string[]) {
  //   let otherDetailWrapperStartTag = `<div class="other-details">`;
  //   let otherDetailWrapperEndTag = `</div>`
  //   if (startKey !== null && data[startKey]) {
  //     const otherFields = Object.keys(data[startKey]).filter((key) => !exclude.includes(key));
  //     for (const field of otherFields) {
  //       console.log(field);
  //       let fieldGroupWrapper = `<div class="field-group">`;
  //       let fieldGroupWrapperEnd = `</div>`
  //       let individualDetailWrapperStart = ""
  //       while (typeof data[startKey][field] == "object") {
  //         individualDetailWrapperStart = fieldGroupWrapper + `<div class="field-group-title">${field}</div><div class="individual-detail">`
  //         let individualDetailWrapperEnd = `</div>`
  //         for (const key of Object.keys(data[startKey][field])) {

  //         }

  //       }
  //       let finalGroup = `
  //       <div class="field-group">
  //                                       <div class="field-value" [innerHTML]="instruction.text">

  //                                       </div>
  //                                       <div class="field-title">
  //                                           Dosage Insructions In Text
  //                                       </div>
  //                                   </div>`

  //       for (let i = 0; i < data[startKey][field].length; i++) {
  //         field
  //       }
  //       let individualDetailWrapperEnd = `</div>`
  //     }
  //   }

  // }

  fieldKeys(data: any, exclude: any[] = []) {
    exclude = this.exclude || exclude;
// $#$    //  /* alert("exclude list "+exclude.join(", ") */);
    if (!this.onlyInclude || this.onlyInclude.length == 0) {
      return Object.keys(data).filter((e) => {
        if (exclude.length !== 0) {


          if (exclude.includes(e)) {
// $#$            // /* alert("excluded " + e); */
            return false
          } else {
            return true
          }

        } else {
          return true;
        }
      });
    } else {
      return Object.keys(data).filter((e) => {
        if (this.onlyInclude.length == 0) {
          return true;
        } else {
          return this.onlyInclude.includes(e);
        }
      });
    }

  }

  renderOtherFields(data: any, key: string = '', parentWrapper: any = null): any {
    //console.log(parentWrapper);
    const elements: string[] = [];

    const isPrimitive = (val: any) =>
      val === null || ['string', 'number', 'boolean'].includes(typeof val);

    //  for (const key in data) {
    if (!data.hasOwnProperty(key)) {
      return '';
    };

    //const fullKey = startKey ? `${startKey}.${key}` : key;
    const value = data[key];

    if (isPrimitive(value)) {
      //  console.log('primitive', value);
      const el = document.createElement('div');
      el.innerHTML = `<div class="mb-8">
      ${['system', 'code', 'display'].includes(key.split('.')[key.split('.').length - 1]) ? "" :
          ` ${key.split('.')[key.split('.').length - 1]} - `
        }${value} </div>`;
      //       el.innerHTML =     ` <div class="field-group">
      //                                         <div class="field-value">
      // ${value}
      //                                         </div>
      //                                         <div class="field-title">
      //                                            ${key.split('.')[key.split('.').length - 1]}
      //                                         </div>
      //                                     </div>`;
      // console.log(el.innerHTML);

      // <strong>: </strong> ${value}`;

      if (!parentWrapper) {
        // console.log(el.innerHTML)
        if (['system', 'code', 'meta'].includes(key.split('.')[key.split('.').length - 1])) {
          return "";
        }
        return el.innerHTML
      } else {
        if (['system', 'code'].includes(key.split('.')[key.split('.').length - 1])) {
          return parentWrapper.innerHTML;
        }
        // console.log(parentWrapper.innerHTML);
        if ((parentWrapper as HTMLElement).children.length) {
          (parentWrapper as HTMLElement).children[(parentWrapper as HTMLElement).children.length - 1].appendChild(el);
        } else {
          parentWrapper.appendChild(el);
        }
        return parentWrapper.innerHTML
      }


      //elements.push(el.innerHTML);

    } else {
      if (value instanceof Array) {
// $#$        // /* alert("Array"); */
        if (!parentWrapper) {
          parentWrapper = document.createElement('div');
          parentWrapper.classList.add('detail-group');
        }
        if (isPrimitive(value[0])) {
          this.renderOtherFields(value, '0', parentWrapper);
        } else {
          for (const k of Object.keys(value[0])) {
            this.renderOtherFields(value[0], k, parentWrapper);
          }
        }
        //  this.renderOtherFields(value, '0', parentWrapper);
      } else {
        // console.log('object', value)
        if (parentWrapper) {
          let childWrapper = document.createElement('div');
          childWrapper.classList.add('detail-group');
          childWrapper.innerHTML = `<div class="detail-group-title"> ${key.split('.')[key.split('.').length - 1]}  </div>`;
          if (['system', 'Coding', 'code'].includes(key.split('.')[key.split('.').length - 1])) {
            parentWrapper.appendChild(childWrapper);
          }

          // console.log(parentWrapper);
        } else {
          parentWrapper = document.createElement('div');
          parentWrapper.classList.add('detail-group');
          if (['system', 'Coding', 'code'].includes(key.split('.')[key.split('.').length - 1])) {
            parentWrapper.innerHTML = `<div class="detail-group-title"> ${key.split('.')[key.split('.').length - 1]}  </div>`;
          }

        }
        for (const k of Object.keys(value)) {
          this.renderOtherFields(value, k, parentWrapper);
        }
      }
      //this.renderOtherFields(value, `$key, parentWrapper);
    }
    // } else {
    //   console.log('val', typeof (value));
    // }
    // }
    //console.log(hugeWrapper);
    // for (const e of elements) {
    //   document.querySelector(".other-details")!.innerHTML += e;
    // }
    // console.log(parentWrapper);
    return parentWrapper.innerHTML
    // ? parentWrapper.innerHTML : '';

  }
  dialog = inject(MatDialog);
  formFieldsDataService = inject(FormFieldsSelectDataService);


  errorService = inject(ErrorService);




}
